/**
 * Content section type enum and CTA type constants.
 * Extracted so that content parsers/schemas can import section enums without a separate types barrel.
 */

export enum ContentSectionType {
  Unknown = "unknown",
  MonthOverview = "month_overview",
  MonthOverviewDetails = "monthly_overview_details",
  MonthlyOverview = "monthly_overview",
  Text = "text",
  Image = "image",
  DataDistribution = "data_distribution",
  Table = "table",
  Chart = "chart",
  Grid = "grid",
  PersonalizedImage = "personalizedImage",
}

/** CTA content type values; use instead of string literals. */
export const CTA_TYPE_BUTTON = "button" as const;
export const CTA_TYPE_BUTTON_OVERLAY = "button_overlay" as const;
/** Content block with `options: [{ condition, cta }]` and nested CTA `type` variants. */
export const CTA_TYPE_CONDITIONAL_CTA = "conditional_cta" as const;

export const CTA_SECTION_TYPES = [
  CTA_TYPE_BUTTON,
  CTA_TYPE_BUTTON_OVERLAY,
  CTA_TYPE_CONDITIONAL_CTA,
] as const;

export type CtaSectionType = (typeof CTA_SECTION_TYPES)[number];

export const isCtaSectionType = (value: string): value is CtaSectionType =>
  (CTA_SECTION_TYPES as readonly string[]).includes(value);

/**
 * Values allowed for `section_type:` chips and `sectionTypesAnyOf` / `sectionTypesAllOf`.
 * Matches keys that can appear in blueprint `content[].type` and search index `sectionTypeCounts`
 * (WYSIWYG section enum members plus CTA section types).
 */
export type SearchSectionTypeFilterKey = ContentSectionType | CtaSectionType;

const searchSectionTypeFilterKeySet = new Set<string>([
  ...Object.values(ContentSectionType),
  ...CTA_SECTION_TYPES,
]);

export const isSearchSectionTypeFilterKey = (
  value: string,
): value is SearchSectionTypeFilterKey =>
  searchSectionTypeFilterKeySet.has(value);
